import { useQuery } from "@tanstack/react-query";
import { useApi } from "../hooks/useApi";
import { format } from "date-fns";
import { FileText, Clock } from "lucide-react";
import { PageHeader } from "../components/PageHeader";

export function AuditLog() {
  const apiClient = useApi();
  const { data: auditData, isLoading } = useQuery({
    queryKey: ["audit"],
    queryFn: () => apiClient.getAuditLog(),
  });

  if (isLoading) {
    return <div className="animate-pulse">Loading audit log...</div>;
  }

  return (
    <div className="space-y-6">
      <PageHeader
        title="Audit Log"
        description="View all system activities and check-in history"
        icon={FileText}
      />

      <div className="bg-white shadow rounded-lg">
        <div className="px-4 py-5 sm:p-6">
          <div className="space-y-4">
            {auditData?.entries?.length ? (
              auditData.entries.map((entry: any) => (
                <div key={entry.id} className="flex items-start space-x-3 p-4 sm:p-0">
                  <div className="flex-shrink-0">
                    <Clock className="h-5 w-5 text-gray-400" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="text-sm">
                      <p className="font-medium text-gray-900">
                        {entry.action
                          .replace("_", " ")
                          .replace(/\b\w/g, (l: string) => l.toUpperCase())}
                      </p>
                      <p className="text-gray-500 text-xs sm:text-sm">
                        {entry.resource} • {format(new Date(entry.timestamp), "PPp")}
                      </p>
                      {entry.details && (
                        <pre className="mt-2 text-xs text-gray-600 bg-gray-50 p-2 rounded overflow-x-auto">
                          {JSON.stringify(entry.details, null, 2)}
                        </pre>
                      )}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-gray-500 text-center py-8">No audit entries found.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
